import React from 'react';
import { Search, Compass, TrendingUp } from 'lucide-react';
import Reveal from './Reveal';

const cases = [
  {
    id: 'cadre',
    tag: 'Cadre dirigeant, 48 ans',
    title: 'Trop de liquidités, une fiscalité lourde',
    situation: "Épargne importante laissée sur des livrets et comptes courants, tranche marginale d’imposition élevée, aucune stratégie retraite formalisée malgré un objectif de départ anticipé.",
    solution: "Bilan patrimonial complet, mise en place d’un Plan d’Épargne Retraite calibré sur le plafond disponible, allocation diversifiée en assurance-vie et poche de précaution redimensionnée.",
    result: "Une fiscalité allégée dès la première année, une épargne qui travaille selon un horizon défini et une trajectoire retraite désormais chiffrée et suivie."
  },
  {
    id: 'famille',
    tag: 'Couple, 62 et 60 ans, deux enfants',
    title: 'Transmettre sans déséquilibrer la famille',
    situation: "Patrimoine immobilier et financier construit sur trente ans, volonté d’aider les enfants dès maintenant tout en préservant le niveau de vie du couple et l’équité entre héritiers.",
    solution: "Donation-partage avec réserve d’usufruit, réécriture des clauses bénéficiaires d’assurance-vie et organisation des flux de revenus, en coordination avec le notaire.",
    result: "Une transmission anticipée, équilibrée et sécurisée juridiquement, des enfants accompagnés dans leurs projets et un couple qui conserve la maîtrise de ses revenus."
  },
  {
    id: 'liberal',
    tag: 'Profession libérale, 40 ans',
    title: 'Investir avec méthode plutôt que par opportunités',
    situation: "Placements accumulés au fil des sollicitations (immobilier locatif, produits divers), sans vision d’ensemble ni lecture claire du risque et des frais réellement supportés.",
    solution: "Cartographie des actifs et des expositions, allocation cible « sécurisé, cœur, satellites », rationalisation des supports et mise en place d’un reporting annuel lisible.",
    result: "Un patrimoine cohérent avec ses objectifs, une diversification réelle et des décisions désormais prises en pleine connaissance de leurs effets."
  }
];

const Step = ({ icon: Icon, label, text }) => (
  <div>
    <div className="flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#ff7300] font-medium"><Icon size={14} /> {label}</div>
    <p className="mt-2 text-sm text-[#010c23]/75 leading-relaxed">{text}</p>
  </div>
);

const CaseStudies = () => (
  <section className="py-24 bg-[#010c23]" data-testid="case-studies">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <Reveal>
        <div className="flex items-center gap-3 mb-4">
          <span className="h-px w-14 bg-[#ff7300]" />
          <span className="text-[11px] tracking-[0.35em] uppercase text-[#ff7300] font-medium">Cas clients</span>
        </div>
        <h2 className="font-serif text-4xl md:text-5xl text-white font-light leading-tight max-w-3xl">Des situations concrètes, des réponses sur mesure</h2>
        <p className="mt-6 text-white/70 max-w-2xl leading-relaxed">Trois exemples inspirés de situations réelles, anonymisés et simplifiés, pour illustrer notre façon de travailler.</p>
      </Reveal>
      <div className="mt-14 grid md:grid-cols-3 gap-6 no-justify">
        {cases.map((c, i) => (
          <Reveal key={c.id} delay={i * 100}>
            <article className="bg-white h-full p-8 flex flex-col gap-6 border-t-2 border-[#ff7300]" data-testid={`case-${c.id}`}>
              <div>
                <p className="text-xs uppercase tracking-widest text-[#010c23]/50">{c.tag}</p>
                <h3 className="font-serif text-2xl text-[#010c23] mt-2 leading-snug">{c.title}</h3>
              </div>
              <Step icon={Search} label="Situation" text={c.situation} />
              <Step icon={Compass} label="Solution" text={c.solution} />
              <Step icon={TrendingUp} label="Résultat" text={c.result} />
            </article>
          </Reveal>
        ))}
      </div>
      <p className="mt-8 text-xs text-white/40 leading-relaxed max-w-3xl">Exemples pédagogiques ne constituant pas une promesse de résultat. Toute stratégie dépend d’une analyse personnalisée de votre situation, de vos objectifs et de votre profil de risque.</p>
    </div>
  </section>
);

export default CaseStudies;
